import axios from "axios";
import Cookies from "universal-cookie";

const apiURL = process.env.NODE_ENV === "development" ? "http://localhost:3001" : process.env.REACT_APP_BACKEND_API_URL;

const cookies = new Cookies();
const token = cookies.get("TOKEN");
const userID = cookies.get("USER_ID");
axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

export const getSaleService = async (office: string, saleID: string) => {
  const token = cookies.get("TOKEN");
  const userID = cookies.get("USER_ID");
  axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
  const res = await axios.get(`${apiURL}/metalstrading/api/sales/${saleID}?office=${office}`);
  return res;
};

export const getBuyerService = async (buyerID: string) => {
  const token = cookies.get("TOKEN");
  const userID = cookies.get("USER_ID");
  axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
  const res = await axios.get(`${apiURL}/metalstrading/api/buyers/${buyerID}`);
  return res;
};

export const getMaterialService = async (materialID: string) => {
  const token = cookies.get("TOKEN");
  const userID = cookies.get("USER_ID");
  axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
  const res = await axios.get(`${apiURL}/metalstrading/api/sales/materials/${materialID}`);
  return res;
};

export const getInvoiceService = async (invoiceID: string, office: string) => {
  const token = cookies.get("TOKEN");
  const userID = cookies.get("USER_ID");
  axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
  const res = await axios.get(`${apiURL}/metalstrading/api/invoices/${invoiceID}?office=${office}`);
  return res;
};

export const getMetalsService = async () => {
  const token = cookies.get("TOKEN");
  const userID = cookies.get("USER_ID");
  axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
  const res = await axios.get(`${apiURL}/metalstrading/api/metals`);
  return res;
};

export const completeInvoiceService = async (invoiceID: string, payload: any) => {
  const token = cookies.get("TOKEN");
  const userID = cookies.get("USER_ID");
  axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
  payload.updatedByUserID = userID;
  const res = await axios.put(`${apiURL}/metalstrading/api/invoices/${invoiceID}/complete`, payload);
  return res;
};
